import React, { useEffect, useState } from "react";
import { Col, FormGroup, Input, Row } from "reactstrap";
import Loading from "../../../components/Loading/Loading";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import LaddersDataService from "../../../services/LaddersService";
import "./ParentLadder.scss";

// Import Advert component for Google ads
import Advert from "../../../components/Advert/Advert";

// Import check/uncheck icons
import checkIcon from "../../../assets/images/checkUnchek/check.png";
import unCheckIcon from "../../../assets/images/checkUnchek/unCheck.png";

const ParentLadder = () => {
  const [loading, setLoading] = useState(false);
  const [studentList, setStudentList] = useState([]);
  const [checkListObj, setCheckListObj] = useState({});
  const [studentId, setStudentId] = useState("");
  const [tagline, setTagline] = useState("");

  useEffect(() => {
    getStudentList();
  }, []);

  const getStudentList = () => {
    setLoading(true);
    LaddersDataService.getParentRoleStudentList()
      .then((res) => {
        if (res?.status === 200) {
          if (res?.data && res?.data?.list && res?.data?.list.length > 0) {
            let studentArr = res?.data?.list || [];
            setStudentList(studentArr);
            setStudentId(studentArr[0]?.id);
            setLoading(false);
          }
        }
      })
      .catch((error) => {
        console.log("error from the service", error);
        setLoading(false);
      });
  };

  const handleChangeStudent = (e) => {
    setStudentId(e.target.value);
    setLoading(true); // Show loader immediately when student changes
  };

  useEffect(() => {
    if (studentList && studentList.length > 0 && studentId) {
      getParentladders();
    }
  }, [studentList, studentId]);

  const getParentladders = () => {
    let payload = {
      studentid: studentId || "",
    };
    setLoading(true);
    LaddersDataService.getParentRoleLadders(payload)
      .then((res) => {
        if (res?.status === 200) {
          if (res?.data) {
            let chekedObj = res?.data?.message[0] || {};
            let tagVal = res?.data?.profile_quote || "";
            setCheckListObj(chekedObj);
            setTagline(tagVal);
            setLoading(false);
          }
        }
      })
      .catch((error) => {
        console.log("error from the service", error);
        setLoading(false);
      });
  };

  const checklistItems = [
    {
      id: 1,
      text: "College Enrollment Ladders Checklist",
      isChecked: checkListObj.complete_all || false,
    },
    {
      id: 2,
      text: "Complete FAFSA",
      isChecked: checkListObj.fafsa || false,
    },
    {
      id: 3,
      text: "Provided Recommendations",
      isChecked: checkListObj.p_recom || false,
    },
    {
      id: 4,
      text: "Completed College Essay",
      isChecked: checkListObj.essay || false,
    },
    {
      id: 5,
      text: "Submitted Transcript",
      isChecked: checkListObj.transcript || false,
    },
    {
      id: 6,
      text: "Paid Application Fees",
      isChecked: checkListObj.paid_fee || false,
    },
  ];

  return (
    <>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="app-main__inner parentLadder">
            {/* Header Section with Google Ad */}
            <div className="ladder-ad-header">
              <div className="header-content">
                {/* Google Ad Section - Centered */}
                <div className="ad-section-centered">
                  <Advert />
                </div>
              </div>
            </div>

            <div className="checklist-container">
              <Row>
                <Col lg="12">
                  <h3 className="checklist-title">College Checklist</h3>
                </Col>
              </Row>
              {studentList && studentList.length > 0 && (
                <Row>
                  <Col lg="12">
                    <FormGroup className="text-left studentSelect">
                      <Input
                        className="form-control"
                        type="select"
                        name="studentId"
                        value={studentId || ""}
                        onChange={handleChangeStudent}
                      >
                        {studentList.map((item, index) => {
                          return (
                            <option key={index} value={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
              )}
              <Row>
                <Col lg="12" className="mx-auto">
                  {loading ? (
                    <div className="loading-container">
                      <Loading />
                    </div>
                  ) : (
                    <div className="checklist-items">
                      {checklistItems.map((item) => (
                        <div key={item.id} className="checklist-item">
                          <span className="item-text">{item.text}</span>
                          <div className="check-icon-wrapper">
                            <img
                              src={item.isChecked ? checkIcon : unCheckIcon}
                              alt={item.isChecked ? "Checked" : "Unchecked"}
                              className="check-icon"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ParentLadder;
